import { render, staticRenderFns } from "./Painel.vue?vue&type=template&id=628e5f6e&scoped=true&"
import script from "./Painel.vue?vue&type=script&lang=js&"
export * from "./Painel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628e5f6e",
  null
  
)

export default component.exports